import { apiUrl } from "../taskpane";

const parseResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.detail || "Request failed";
    const error = new Error(message);
    error.status = response.status;
    error.body = data;
    throw error;
  }
  return data;
};

export async function loginRequest(email, password) {
  const res = await fetch(apiUrl("login"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return parseResponse(res);
}

export async function fetchRoles(token) {
  const res = await fetch(apiUrl("me/roles"), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}

export async function fetchDatabaseGrants(token) {
  const res = await fetch(apiUrl("me/database-grants"), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}

export async function fetchProfile(token) {
  const res = await fetch(apiUrl("me/profile"), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}
